import { useForm } from 'react-hook-form'
import { useNavigate, useLocation, useOutletContext } from 'react-router-dom'
import { nextPage } from 'components/RCPro/helpers/nav'
//import SelectCompany from 'components/RCPro/components/form/SelectCompany/SelectCompany'
import CompanyName from 'components/RCPro/components/form/CompanyName/CompanyName'
import CompanySiret from 'components/RCPro/components/form/CompanySiret/CompanySiret'
import CompanyAddress from 'components/RCPro/components/form/CompanyAddress/CompanyAddress'
import CompanyCity from 'components/RCPro/components/form/CompanyCity/CompanyCity'
import Arrow from 'components/assets/icons/Arrow'
import Button from 'components/common/Button/Button'
import { formParams } from 'constants/inputValidation'

const RCProCompany = () => {
  const navigate = useNavigate()
  const [ nextPageTransition ] = useOutletContext()
  const { state, pathname } = useLocation()
  const { company, layout: { next } } = state.texts

  // Initialize form
  const {
    register,
    formState: { errors, isValid },
    handleSubmit
  } = useForm({
    ...formParams,
    values: {
      //company: state.company,
      organizationName: state.organizationName,
      companyImmatriculation: state.companyImmatriculation,
      headquarterAddress: state.headquarterAddress,
      headquarterCity: state.headquarterCity,
    },
  })

  // const onCompanyChange = datas => {
  //   setValue('company', datas)
  //   trigger()
  // }

  const onSubmit = handleSubmit(async data => {
    nextPage({ pathname, state, navigate, data })
    nextPageTransition()
  })

  return (
    <>
      <h1>{company.title.replace(/{{.+}}/, state.firstname)} 💼</h1>

      <form onSubmit={onSubmit}>
        {/* <SelectCompany
          register={register}
          error={errors.company}
          onChange={onCompanyChange}
        /> */}

        <CompanyName
          register={register}
          error={errors.organizationName}
        />
        
        <CompanySiret
          register={register}
          error={errors.companyImmatriculation}
        />

        <CompanyAddress
          register={register}
          error={errors.headquarterAddress}
        />

        <CompanyCity
          register={register}
          error={errors.headquarterCity}
        />

        <Button
          label={<>{next} <Arrow /></>}
          onClick={handleSubmit}
          disabled={!isValid}
          type="primary"
        />
      </form>
    </>
  )
}

export default RCProCompany